<template>
    <div class="cart-icon" @click.prevent="cartOpened = true">
        <img src="@/assets/icons/shopping-basket.svg" alt="" />
        <span v-if="Boolean(allShoppingCart.length) && Boolean(allShoppingCart[0].products?.length)">{{allShoppingCart[0].products.length}}</span>
    </div>

    <div class="cart"
        :class="{'cart--opened' : cartOpened}"
    >
        <div class="cart__top">
            <button class="cart__top-close" @click.prevent="cartOpened = false">
                <img src="@/assets/icons/close-basket.svg" alt="" />
            </button>
            <div class="cart__top-left">
<!--                <button><img src="@/assets/icons/back-basket.svg" alt="" /></button>-->
                <span>{{projectName}}</span>
            </div>
            <div class="cart__top-right">
<!--                <button><img style="width: 25px;" src="@/assets/icons/menu.svg" alt="" /></button>-->
<!--                <button><img src="@/assets/icons/add-basket.svg" alt="" /></button>-->
            </div>
        </div>
        <div class="cart__content">
<!--            <div class="cart__searcher">-->
<!--                <div>-->
<!--                    <input type="text" placeholder="Szukaj..." />-->
<!--                </div>-->
<!--            </div>-->

            <template v-if="!allShoppingCart.length">
                <p class="cart__empty">{{$t('shopping_cart.cart_is_empty')}}</p>
            </template>

            <div class="cart__item-wrapper" v-for="(cart,index) in allShoppingCart">
                <div class="cart__item" @click="openCartDetails[cart.id] = !openCartDetails[cart.id]">
                    <p>{{cart.name}} <span>{{cart.products.length}}</span></p>
                </div>
                <Transition>
                    <div class="cart__item-content">
<!--                    <button class="cart__item-content-close">-->
<!--                        <img src="https://via.placeholder.com/14" alt="" />-->
<!--                    </button>-->
                    <div class="cart__product" v-for="(product,index) in cart.products">
                        <div class="cart__product-remove">
                            <p @click="removeProductFromShoppingCart(cart.id,product)">x</p>
                        </div>
                        <div class="cart__product-left">
                            <div
                                class="cart__product-image"
                                :style="{backgroundImage: 'url(' + product.imagePath + ')'}"
                            ></div>
                            <div>
                                <p>{{product.name}}</p>
                                <p>{{$t('shopping_cart.price')}}: {{product.price}}</p>
                            </div>
                        </div>
                        <div class="cart__product-right">
                            <div class="control control--input control-number">
                                <label class="control__label">{{$t('shopping_cart.amount')}}</label>
                                <div>
                                    <button type="button" data-type="dec" @click="decrementProduct(product,cart)">-</button>
                                    <input type="text" :value="product.amount" />
                                    <button type="button" data-type="inc" @click="incrementProduct(product,cart)">+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cart__summary">
                        <div class="cart__price">{{cart.totalValue}}</div>
<!--                        <div class="cart__loan">Raty: 12 x 12 PLN</div>-->

                        <div class="cart__checkout">
                            <button :class="{'disabled-button': !!loading}" @click="paymentForCart(cart)">
                                <template v-if="!loading">{{$t('shopping_cart.payment')}}</template>
                                <template v-else>{{$t('shopping_cart.during_payment')}}</template>
                            </button>
                        </div>
                    </div>
                </div>
                </Transition>
            </div>
            <p class="cart__content-info"></p>
<!--            <p class="cart__content-info">Stwórz koszyk, aby dodać produkty</p>-->
        </div>
    </div>

    <confirm-delete-product-from-cart
        ref="confirmDelete"
        @removeProduct="removeProductFromCart"
    />
</template>

<script>
/*
FOR NOW BASKET WORKS:
 - ONLY IN PRODUCT DETAILS.
 - ONLY FOR CLIENT.
*/
import {ref, onMounted, inject, reactive} from "vue";
import ShoppingCartService from "@/services/ShopingCart/shoppingCart.service";
import router from "@/router";
import AlertHelper from "@/helpsers/alert.helper";
import ApiHelper from "@/helpsers/api.helper";
import {useI18n} from "vue-i18n";
import axios from "axios";
import ConfirmDeleteProductFromCart from "@/components/cart/ConfirmDeleteProductFromCart";
import shoppingCartService from "@/services/ShopingCart/shoppingCart.service";

export default {
    name: "Cart",
    components: {ConfirmDeleteProductFromCart},
    setup() {
        const cartOpened = ref(false),
            alert = inject('alert'),
            {t} = useI18n(),
            shoppingCart = new ShoppingCartService(),
            projectId = router.currentRoute.value.params.id,
            allShoppingCart = ref([]),
            cartMessage = ref(''),
            emitter = inject('emitter'),
            openCartDetails = reactive({}),
            confirmDelete = ref(),
            loading = ref(false),
            projectName = ref('');

        emitter.on('updateShoppingCart',(result) => {
           updateProductInCart(result);
        })

        onMounted( () => {
            getAllShopingCart();
            getProjectName();
        })

        function updateProductInCart(result) {
            const basketId = result.data.id;
            if( allShoppingCart.value.length > 0)
                allShoppingCart.value.find((basket,index) => {
                    if(basket.id == basketId) {
                        allShoppingCart.value[index].products = result.data.products;
                        allShoppingCart.value[index].totalValue = result.data.totalValue;
                    }
                });
            else
                allShoppingCart.value.push(result.data)
        }

        async function getAllShopingCart() {
            try {
                allShoppingCart.value = (await shoppingCart.getAllShoppingCart(projectId)).data;
            }
            catch (e) {
                if(e.response.status >= 500) {
                    const errorMessage = ApiHelper.getResponseMessage(e.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, 'Błąd pobierania koszyka dla tego projektu', 'error');
                }
                else
                    cartMessage.value = t('shopping_cart.cart_is_empty');
            }
        }

        async function getProjectName() {
            try {
                projectName.value = await shoppingCart.getProjectName();
            }
            catch (e) {
                const errorMessage = ApiHelper.getResponseMessage(e.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
            }
        }


        function decrementProduct(product,cart) {
            const prevProductAmount = product.amount;
            product.amount > 1 ? --product.amount: '';
            changeProductAmount(product,cart,prevProductAmount);
        }

        function incrementProduct(product,cart) {
            const prevProductAmount = product.amount;
            product.amount >= 1 ? ++product.amount : '';
            changeProductAmount(product,cart,prevProductAmount);
        }

        async function changeProductAmount(product,cart, prevProductAmount) {
            try {
                if(product.amount > 0) {
                    const result = await shoppingCart.changeProductAmount(product, cart.id);
                    cart.totalValue = result.data.totalValue;
                }
            }
            catch (e) {
                const errorMessage = ApiHelper.getResponseMessage(e.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
                product.amount = prevProductAmount;
            }
        }

        function removeProductFromShoppingCart(cartId, product) {
            confirmDelete.value.showModal(cartId, product);
        }

        function removeProductFromCart(result) {
            updateProductInCart(result);
        }

        async function paymentForCart(cart) {
            loading.value = true;
            try {
                if(cart.products.length > 0) {
                    const result = await shoppingCart.paymentForShoppingCart(cart.id);
                    loading.value = false;
                    window.open(result.data.paymentLink);
                }
                else {
                    loading.value = false;
                    AlertHelper.show(alert, t('shopping_cart.cart_is_empty'), '', 'error');
                }

            }
            catch (e) {
                const errorMessage = ApiHelper.getResponseMessage(e.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
                loading.value = true;
            }
        }

        return {
            cartOpened,
            allShoppingCart,
            cartMessage,
            openCartDetails,
            decrementProduct,
            incrementProduct,
            projectName,
            removeProductFromShoppingCart,
            confirmDelete,
            removeProductFromCart,
            paymentForCart,
            loading,
        }
    }
}
</script>

<style scoped lang="scss">
@use "@/css/cart";

.cart {
    top: 53%;
    &__content {
        max-height: 70vh;

        &-info {
            //display: none;
        }
    }
    &__searcher > div:after {
        background-image: url("@/assets/icons/search-basket.svg");
    }

    &__checkout {
        .disabled-button {
            background-color: #8a8a8a !important;
            cursor: no-drop !important;
        }
        button {
            width: 235px;
            height: 52px;
            background: #529096 0% 0% no-repeat padding-box;
            border-radius: 5px;
            color: #f4f3f3;
            font: normal normal 500 2rem/24px Montserrat;
            border: none;
            display: block;
            margin: 29px auto;
            cursor: pointer;

            &:hover {
                background-color: #65a9b0;
            }
        }
    }

    &__empty {
        text-align: center;
        font-size: 1.8rem;
        font-weight: 500;
        margin-top: 20px;
    }

    &__item {
        cursor: pointer;
        &:hover {
            background-color: #529096;
        }
        &-content {
            display: block;

        }
        &-wrapper {
            margin-top: 10px;
        }
    }

    &__top {
        &-close {
            cursor: pointer;
        }
    }

    &__product {
        position: relative;
        &-remove {
            position: absolute;
            top: 10px;
            right: 20px;
            font-size: 2rem;
            cursor: pointer;
        }
    }
}

.cart-icon {
    width: 80px;
    height: 60px;

    img {
        width: 40px;
    }
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
    transition: opacity 0.1s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>